import { render, staticRenderFns } from "./TopicContents.vue?vue&type=template&id=44ac2a5a&scoped=true&"
import script from "./TopicContents.vue?vue&type=script&lang=js&"
export * from "./TopicContents.vue?vue&type=script&lang=js&"
import style0 from "./TopicContents.vue?vue&type=style&index=0&id=44ac2a5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ac2a5a",
  null
  
)

export default component.exports